<template>
  <div v-if="labels" class="blog-labels">
    <span
      v-for="item in labels"
      :key="item.name + item.color"
      :style="`background-color: ${item.color}`"
      class="blog-labels__item"
    >
      {{ item.name }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();

const labels = computed(() => resultsStore.blogElement?.labels);
</script>

<style lang="scss" scoped>
.blog-labels {
  display: flex;
  flex-wrap: wrap;
  &__item {
    display: inline-block;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    padding: 4px 6px;
    //margin-bottom: 8px;
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
}
</style>
